import { render, staticRenderFns } from "./c-panel.vue?vue&type=template&id=5b303540"
import script from "./c-panel.vue?vue&type=script&lang=js"
export * from "./c-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports